<template>
  <header class="app-header navbar" :class="isDark ? 'bg-dark navbar-dark' : 'bg-white navbar-light'">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>

    <b-link class="navbar-brand" to="#" :class="isDark ? 'bg-dark' : ''"></b-link>

    <button class="navbar-toggler sidebar-toggler d-md-down-none" type="button" @click="sidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Botão de Alternância de Tema (Lua) -->
    <button
      class="navbar-toggler border-0 d-md-down-none"
      type="button"
      @click="toggleTema"
      title="Alternar Tema Escuro"
      style="outline: none; box-shadow: none; background: transparent;"
    >
      <i
        class="fa fa-moon-o hover-scale"
        :class="isDark ? 'text-white' : 'text-secondary'"
        style="font-size: 1.2rem; transition: transform 0.2s ease, color 0.2s ease;"
      ></i>
    </button>

    <!-- Nome da empresa — chip glassmorphism -->
    <b-navbar-nav class="d-md-down-none ml-2">
      <b-nav-item class="px-1">
        <span class="empresa-chip" :class="isDark ? 'empresa-chip--dark' : 'empresa-chip--light'">
          <i class="fa fa-building-o empresa-chip__icon"></i>
          <span class="empresa-chip__nome">{{ nomeEmpresa }}</span>
        </span>
      </b-nav-item>
    </b-navbar-nav>

    <!-- Ações do lado direito -->
    <b-navbar-nav class="ml-auto">
      <b-nav-item class="d-md-down-none">
        <i class="icon-bell"></i>
        <b-badge pill :variant="isDark ? 'light' : 'danger'">0</b-badge>
      </b-nav-item>
      <b-nav-item class="d-md-down-none">
        <i class="icon-list"></i>
      </b-nav-item>
      <b-nav-item class="d-md-down-none">
        <i class="icon-location-pin"></i>
      </b-nav-item>
      <HeaderDropdown/>
    </b-navbar-nav>

    <button class="navbar-toggler aside-menu-toggler d-md-down-none" type="button" @click="asideToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
  </header>
</template>

<script>
  import HeaderDropdown from './HeaderDropdown.vue'

  export default {
    data: function () {
      return {
        nomeEmpresa: ''
      }
    },
    name: 'c-header',
    components: {
      HeaderDropdown
    },
    methods: {
      sidebarToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-hidden')
      },
      sidebarMinimize (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-minimized')
      },
      mobileSidebarToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-mobile-show')
      },
      asideToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('aside-menu-hidden')
      },
      toggleTema() {
        const novoTema = !this.isDark

        // 1) Persiste no localStorage
        localStorage.setItem('tema', novoTema ? 'D' : 'L')

        // 2) Atualiza o store do Vuex (propaga a reatividade imediatamente em todo o app)
        this.$store.commit('tema/SET_IS_DARK', novoTema)

        // 3) Sincroniza com a tabela de usuários no banco de dados via API
        const usuarioId = localStorage.getItem('usuarioId')
        if (usuarioId) {
          this.$http.post(`/api/protected/usuario/mudarTema/`, {
            usuarioId: usuarioId,
            tema: novoTema ? 'D' : 'L'
          }).catch(() => {
            // falha silenciosa para não incomodar o usuário
          })
        }
      }
    },
    mounted () {
      this.nomeEmpresa = window.localStorage.getItem('nomeempresa') || ''
    },
    computed: {
      isDark() {
        return this.$store.getters['tema/IS_DARK']
      }
    }
  }
</script>

<style scoped>
  .hover-scale {
    cursor: pointer;
    display: inline-block;
  }
  .hover-scale:hover {
    transform: scale(1.2);
  }
</style>

<style>
  /* Força o fundo da logo a ser transparente e mesclar com o tema escuro */
  body.theme-dark .app-header.navbar {
    background-color: #1a1c23 !important;
  }
  body.theme-dark .app-header.navbar .navbar-brand {
    background-color: transparent !important;
    border: none !important;
    mix-blend-mode: screen !important;
  }

  /* ── Chip glassmorphism — nome da empresa ── */
  .empresa-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 12px 4px 10px;
    border-radius: 20px;
    font-size: 0.78rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    white-space: nowrap;
    transition: all 0.25s ease;
    cursor: default;
    user-select: none;
  }

  /* Tema claro */
  .empresa-chip--light {
    background: rgba(59, 130, 246, 0.08);
    border: 1px solid rgba(59, 130, 246, 0.25);
    color: #2563eb;
  }
  .empresa-chip--light .empresa-chip__icon {
    color: #3b82f6;
    font-size: 0.82rem;
  }
  .empresa-chip--light:hover {
    background: rgba(59, 130, 246, 0.14);
    border-color: rgba(59, 130, 246, 0.4);
  }

  /* Tema escuro */
  .empresa-chip--dark {
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.14);
    color: #cbd5e1;
    backdrop-filter: blur(4px);
  }
  .empresa-chip--dark .empresa-chip__icon {
    color: #7dd3fc;
    font-size: 0.82rem;
  }
  .empresa-chip--dark:hover {
    background: rgba(255, 255, 255, 0.10);
    border-color: rgba(255, 255, 255, 0.22);
    color: #f1f5f9;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header/Header.vue